import React from 'react';
import CustomTimePicker from './CustomTimePicker';
import './TimeRangePicker.css';

const TimeRangePicker = ({
  startId,
  endId,
  startTime,
  endTime,
  onStartChange,
  onEndChange,
  startPlaceholder = 'Start time',
  endPlaceholder = 'End time',
  blockedTimes,
  blockedEndTimes,
  minEndTime,
  endDisabled = false,
  dropdownBelow = false,
  attached = false,
  className = '',
}) => (
  <div className={`time-range-picker time-pickers${attached ? ' time-range-picker--attached' : ''}${className ? ` ${className}` : ''}`}>
    <div className="time-picker">
      <CustomTimePicker
        id={startId}
        value={startTime}
        onChange={onStartChange}
        placeholder={startPlaceholder}
        type="start"
        blockedTimes={blockedTimes}
        dropdownBelow={dropdownBelow}
      />
    </div>
    <span className="time-pickers-to" aria-hidden="true">
      <img src="/manual-booking/icons/arrow-right-to.png" alt="" className="time-pickers-to-icon" />
    </span>
    <div className="time-picker">
      <CustomTimePicker
        id={endId}
        value={endTime}
        onChange={onEndChange}
        placeholder={endPlaceholder}
        type="end"
        minTime={minEndTime}
        blockedTimes={blockedEndTimes}
        disabled={endDisabled}
        dropdownBelow={dropdownBelow}
      />
    </div>
  </div>
);

export default TimeRangePicker;
